import { epoch, utc } from '../../util/datetime';
import { SubscriptionStatusType, SubscriptionType } from './Subscription.enum';
import type { ISubscriptionDetails } from './SubscriptionDetails.interface';

export default class SubscriptionDetails implements ISubscriptionDetails {
  id: string;
  type: SubscriptionType;
  name: string;
  customer: string;
  quantity: number;
  amount: number;
  created: number;
  trialStart: number;
  trialEnd: number;
  start: number;
  periodStart: number;
  periodEnd: number;
  cancelledAt: number;
  cancelAtPeriodEnd: boolean;
  status: SubscriptionStatusType;
  active: boolean;

  getStatusTitle() {
    if (this.isCancelled()) {
      return 'Cancelled';
    }
    return this.status.title();
  }

  isCancelled() {
    return this.cancelledAt && this.cancelAtPeriodEnd === true && utc(this.periodEnd) < utc();
  }

  isStatusActive() {
    return (
      this.status === SubscriptionStatusType.trialing ||
      this.status === SubscriptionStatusType.active
    );
  }

  isStatusInactive() {
    return !this.isStatusActive();
  }

  isActive() {
    return this.isStatusActive() && this.active === true;
  }

  static build = (data: ISubscriptionDetails) => new SubscriptionDetails(data);
  static blank = () => new SubscriptionDetails();

  /**
   * Constructor
   * @param {ISubscriptionDetails} data
   */
  constructor(data?: ISubscriptionDetails) {
    /* eslint-disable camelcase */
    this.id = data?.id || undefined;
    this.type = SubscriptionType.of(data?.plan?.id);
    this.name = data?.plan?.name || undefined;
    this.customer = data?.customer || undefined;
    this.quantity = parseInt(data?.quantity || 0, 10);
    this.amount = parseFloat(data?.plan?.amount || 0);
    this.created = epoch(utc(data?.plan?.created));
    this.trialStart = epoch(utc(data?.trial_start));
    this.trialEnd = epoch(utc(data?.trial_end));
    this.start = epoch(utc(data?.start));
    this.periodStart = epoch(utc(data?.current_period_start));
    this.periodEnd = epoch(utc(data?.current_period_end));
    this.cancelledAt = epoch(utc(data?.cancelled_at));
    this.cancelAtPeriodEnd = epoch(utc(data?.cancel_at_period_end));
    this.status = SubscriptionStatusType.of(data?.status);
    this.active = data?.plan?.active === true;
    /* eslint-enable camelcase */
  }
}
